<template>
  <section class="app-body search">
    <search-container :class="`app-body_show container-fluid pt-4 pb-5`"
      :isLandscape="!!$route.meta.isLandscape"
    ></search-container>
  </section>
</template>

<script>
import SearchContainer from '@/containers/Search'

import { mapActions } from 'vuex'

export default {
  name: 'searchShow',
  metaInfo: {
    titleTemplate: 'Search | AcademicLabs'
  },
  components: {
    SearchContainer
  },
  data () {
    return {
      state: {},
      count: 0,
      counts: {},
      toggleSearch: false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.isEmpty(to.params.id) && to.params.id !== undefined) {
      // Store current search route for "Back to search" functionality
      if (from.name === 'search' && to.name !== 'search') {
        const path = from.fullPath
        this.setLastClickedResult({
          id: `${this.singularizeIndex(from.params.category)}-${to.params.id}`,
          fromSearch: true,
          fromRoute: path
        })
      }
    }
    next()
  },
  beforeRouteUpdate (to, from, next) {
    this.checkOpenModal(to.query)
    next()
  },
  mounted () {
    this.checkOpenModal(this.$route.query)
  },
  methods: {
    ...mapActions('search', [
      'setLastClickedResult'
    ])
  }
}
</script>
